import React from 'react';
import ReadOnlyTemplate from '../components/ReadOnlyTemplate';
import { cryptocurrencyData } from '../data/cryptocurrencyData';

const Cryptocurrency = () => {
  return (
    <ReadOnlyTemplate
      title="Cryptocurrency"
      sections={cryptocurrencyData}
    />
  );
};

export default Cryptocurrency;
